module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-referral"
  }, [(_vm.headerText) ? _c('div', {
    staticClass: "cb-referral__heading"
  }, [_vm._v("\n    " + _vm._s(_vm.headerText) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.text1 || _vm.text2) ? _c('div', {
    staticClass: "cb-referral__desc"
  }, [_vm._v("\n    " + _vm._s(_vm.text1) + "\n    " + _vm._s(_vm.text2) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cb-section cb-text"
  }, [_c('input', {
    ref: "input",
    staticClass: "cb-text__control cb-text__control--left",
    class: {
      'cb-field__readonly-dark': _vm.hosted_page_type != 'portal'
    },
    attrs: {
      "type": "text",
      "readonly": "true",
      "id": "referral_url"
    },
    domProps: {
      "value": _vm.referral_url
    }
  }), _vm._v(" "), _c('button-field', {
    attrs: {
      "custom-class": 'primary icon field',
      "attr": 'referral_copy'
    },
    on: {
      "next": function($event) {
        _vm.doCopy()
      }
    }
  }, [_c('span', {
    staticClass: "cb-sm"
  }, [_vm._v(_vm._s(_vm.copyText))])])], 1), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d1ab728"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/hosted-pages/ReferralComponent.vue
// module id = 120
// module chunks = 66 67 68 69